import React from 'react';
import { useSelector } from 'react-redux';
import { emulatorSelector } from 'redux/slices/emulator';
import { useAuthContext } from 'providers/auth-provider';

const bannerStyles = {
  background: 'red',
  color: 'white',
  textAlign: 'center',
  marginBottom: '4px',
  borderRadius: '6px',
  fontStyle: 'normal',
  fontWeight: '600',
  paddingBlock: '4px',
};

export const EmulationBanner = () => {
  const { user } = useAuthContext();
  const {
    firstName, lastName, userId, sessionId,
  } = useSelector(emulatorSelector);

  if (!sessionId || !user) return null;

  return (
    <div style={bannerStyles}>
      {firstName && lastName ? `${firstName} ${lastName}` : `User ${userId}`}
      {' '}
      is emulating
      {' '}
      {`${user.first_name} ${user.last_name}`}
    </div>
  );
};
